import {
    ConfluenceTemplateCollectionDetailsRelayPageTemplate,
    ConfluenceTemplateCollectionDetailsRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-template-collection-details-contentful-relay-page.template.tsx";
export type ConfluenceTemplateCollectionDetailsRelayPageProps =
    ConfluenceTemplateCollectionDetailsRelayPageTemplateProps;

export const ConfluenceTemplateCollectionDetailsRelayPage = ({
    queryRef
}: ConfluenceTemplateCollectionDetailsRelayPageProps) => {
    return (
        <ConfluenceTemplateCollectionDetailsRelayPageTemplate
            queryRef={queryRef}
        />
    );
};
